import { TWhiteLabelStore } from '../white-label.model';

export function setPanelFontHighlight(
  themeWrapper: HTMLBodyElement,
  whiteLabel: TWhiteLabelStore,
): void {
  themeWrapper.style.setProperty('--panelFontHighlight', whiteLabel.data.panelFontHighlight);
}
